package com.milta.core.mode

enum class AppMode {
    ENTERPRISE,
    DRIVER,
}
